let _lastHighlighted = null;
let _lastHighlightTimer = null;

export function highlight(el, color = "#3b82f6", duration = 900) {
  if (!el) return;
  if (_lastHighlighted && _lastHighlighted !== el) {
    _lastHighlighted.style.outline         = "";
    _lastHighlighted.style.backgroundColor = "";
    _lastHighlighted.style.transition      = "";
  }
  if (_lastHighlightTimer) {
    clearTimeout(_lastHighlightTimer);
    _lastHighlightTimer = null;
  }

  el.style.outline         = `3px solid ${color}`;
  el.style.backgroundColor = `${color}22`;
  el.style.transition      = "outline 0.15s, background-color 0.15s";
  _lastHighlighted = el;

  _lastHighlightTimer = setTimeout(() => {
    if (_lastHighlighted === el) {
      el.style.outline         = "";
      el.style.backgroundColor = "";
      el.style.transition      = "";
      _lastHighlighted  = null;
      _lastHighlightTimer = null;
    }
  }, duration);
}

export function fillReactInput(el, value) {
  if (!el) return false;
  const proto  = Object.getPrototypeOf(el) === HTMLTextAreaElement.prototype
    ? window.HTMLTextAreaElement.prototype
    : window.HTMLInputElement.prototype;
  const setter = Object.getOwnPropertyDescriptor(proto, "value")?.set;
  if (setter) {
    setter.call(el, value);
  } else {
    el.value = value;
  }
  el.dispatchEvent(new Event("input",  { bubbles: true }));
  el.dispatchEvent(new Event("change", { bubbles: true }));
  el.dispatchEvent(new KeyboardEvent("keyup",  { bubbles: true }));
  return true;
}

export function triggerClick(el) {
  if (!el) return false;
  highlight(el, "#3b82f6");
  ["mousedown", "mouseup", "click"].forEach(type =>
    el.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true }))
  );
  return true;
}
export async function executeStructuredAction(action) {
  const { selector, text, value } = action;

  if (action.action === "click") {
    const aiAgent =
      action.ai_agent ||
      action.aiAgent ||
      "";
    const clickText = (text || "").toLowerCase().trim();
    if (clickText) {
      const submitCandidates = [
        ...document.querySelectorAll("button, input[type='submit'], input[type='button']"),
      ].filter(isVisible);
      for (const btn of submitCandidates) {
        const lbl = (btn.innerText || btn.value || btn.getAttribute("aria-label") || "")
          .replace(/\s+/g, " ").trim().toLowerCase();
        if (lbl === clickText || lbl.startsWith(clickText)) {
          highlight(btn, "#3b82f6");
          triggerClick(btn);
          return { success: true, found: true };
        }
      }
    }
    if (aiAgent) {

      const el = _findByAiAgent(aiAgent);

      if (el) {
        highlight(el, "#3b82f6");
        triggerClick(el);

        return {
          success: true,
          found: true
        };
      }
    }
    if (selector) {
      const el = _resolveClickable(selector);
      if (el) { highlight(el, "#3b82f6"); triggerClick(el); return { success: true, found: true }; }
    }
    if (text) {
      const ok = _clickByText(text);
      return { success: ok, found: ok };
    }
    return { success: false, found: false };
  }

  if (action.action === "fill") {
    if (selector) {
      const el = document.querySelector(selector);
      if (el && _isInputLike(el)) {
        highlight(el, "#10b981");
        el.focus();
        fillReactInput(el, value ?? "");
        setTimeout(() => el.blur(), 100);
        return { success: true, found: true };
      }
    }
    if (text) {
      const ok = _typeIntoField(text, value ?? "");
      return { success: ok, found: ok };
    }
    return { success: false, found: false };
  }

  if (action.action === "select") {
    console.log(
      "SELECT ACTION",
      action
    );
    const aiAgent =
      action.ai_agent ||
      action.aiAgent ||
      "";
    const wantValue  = (value || action.input || "").toLowerCase().trim();
    const wantTarget = (text  || action.target || "").toLowerCase().replace(/[*✱✻†‡•]+/g, "").trim();
    function _wrapperFromSelector(sel) {
      try {

        const el =
          document.querySelector(sel);

        if (!el) return null;
        if (
          [...(el.classList || [])].some(
            c =>
              c === "react-select__control" ||
              c.endsWith("-control")
          )
        ) {
          return el;
        }
        const control =
          el.querySelector?.(
            '.react-select__control, [class$="-control"]'
          );

        if (control) return control;

        return (
          el.closest?.(
            '.react-select__control, [class$="-control"]'
          ) ||
          el.closest?.(
            ".CustomSelect"
          ) ||
          null
        );

      } catch (_) {
        return null;
      }
    }

    if (selector) {
      try {
        const el = document.querySelector(selector);
        if (el && el.tagName === "SELECT") {
          const opt = [...el.options].find(
            o => o.text.toLowerCase().includes(wantValue) || o.value.toLowerCase() === wantValue
          );
          if (opt) {
            const setter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, "value")?.set;
            if (setter) setter.call(el, opt.value); else el.value = opt.value;
            el.dispatchEvent(new Event("change", { bubbles: true }));
            highlight(el, "#8b5cf6");
            return { success: true, found: true };
          }
        }
      } catch (_) {}
    }

    if (aiAgent) {

      const el = _findByAiAgent(aiAgent);

      if (el) {

        const wrapper =
          el.closest('.react-select__control, [class$="-control"]') ||
          el.closest(".CustomSelect") ||
          el;

        const ok = await _openCustomSelectAndPick(wrapper, wantValue);

        return {
          success: ok,
          found: !!wrapper,
          selected: ok
        };
      }
    }

    if (selector) {
      const el = document.querySelector(selector);

      const wrapper =
        el?.closest('.react-select__control, [class$="-control"]') ||
        el?.querySelector?.('.react-select__control, [class$="-control"]');


      if (wrapper) {
        const ok =
          await _openCustomSelectAndPick(
            wrapper,
            wantValue
          );

        return {
          success: ok,
          found: true,
          selected: ok
        };
      }
    }

    if (wantTarget) {
      const wrapper =
        _findCustomSelectByLabel(
          wantTarget
        ) ||
        _wrapperFromSelector(
          action.selector
        );
      if (wrapper) {
        const ok = await _openCustomSelectAndPick(wrapper, wantValue);

        return {
          success: ok,
          found: !!wrapper,
          selected: ok
        };
      }
    }

    const ok = _selectNativeByLabel(wantTarget, wantValue);
    return { success: ok, found: ok };
  }

  if (action.action === "toggle") {
    const label = (text || action.text || action.description || "").toLowerCase();
    let el = null;
    if (selector) { try { el = document.querySelector(selector); } catch (_) {} }
    if (!el && label) {
      el = [...document.querySelectorAll(
        'input[type="checkbox"], input[type="radio"], [role="switch"], [role="checkbox"]'
      )].find(e =>
        (getLabel(e) || e.closest("tr,div,label,li")?.innerText || "").toLowerCase().includes(label)
      );
    }
    if (!el) return { success: false, found: false };
    highlight(el, "#f59e0b");
    el.click();
    return { success: true, found: true };
  }

  if (action.action === "upload_file") {
    let fileInput = null;
    if (selector) { try { fileInput = document.querySelector(selector); } catch (_) {} }
    if (!fileInput) {
      fileInput = [...document.querySelectorAll('input[type="file"]')].find(isVisible);
    }
    if (!fileInput) return { success: false, found: false };
    const [header, b64] = (action.data_url || "").split(",");
    const mime = (header?.match(/:(.*?);/) || [])[1] || "image/jpeg";
    const binary = atob(b64 || "");
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    const file = new File(
      [new Blob([bytes], { type: mime })],
      action.filename || "image.jpg",
      { type: mime }
    );
    const dt = new DataTransfer();
    dt.items.add(file);
    fileInput.files = dt.files;
    fileInput.dispatchEvent(new Event("change", { bubbles: true }));
    fileInput.dispatchEvent(new Event("input",  { bubbles: true }));
    highlight(fileInput, "#10b981");
    return { success: true, found: true };
  }

  return { success: false, found: false };
}

function _isInputLike(el) {
  const t = el.tagName.toLowerCase();
  return t === "input" || t === "textarea" || t === "select";
}

function _findByAiAgent(aiAgent) {
  if (!aiAgent) return null;

  return document.querySelector(
    `[data-ai-agent="${aiAgent}"]`
  );
}

function _resolveClickable(selector) {
  try {
    const el = document.querySelector(selector);
    if (!el) return null;
    const tag  = el.tagName;
    const role = el.getAttribute?.("role") || "";
    if (tag === "BUTTON" || tag === "INPUT" || tag === "A" ||
        role === "button" || role === "tab" || role === "menuitem") {
      return el;
    }

    const innerBtn = el.querySelector("button, input[type='submit'], input[type='button'], a[role='button']");
    if (innerBtn && isVisible(innerBtn)) return innerBtn;
    return getClickableAncestor(el) || el;
  } catch (_) {
    return null;
  }
}

function splitWords(str) {
  const words = [];
  let cur = "";
  for (let i = 0; i < str.length; i++) {
    const c = str.charCodeAt(i);
    const isAlpha = (c >= 97 && c <= 122) || (c >= 65 && c <= 90) || (c >= 48 && c <= 57);
    if (isAlpha) { cur += str[i]; }
    else { if (cur.length > 1) words.push(cur.toLowerCase()); cur = ""; }
  }
  if (cur.length > 1) words.push(cur.toLowerCase());
  return words;
}

function scoreMatch(target, source) {
  if (!target || !source) return 0;
  const t = target.toLowerCase().trim();
  const s = source.toLowerCase().trim();
  if (s === t) return 100;
  if (s.startsWith(t)) return 85;
  if (s.includes(t)) return 70;
  if (t.includes(s) && s.length > 2) return 55;
  const tw = new Set(splitWords(t)), sw = new Set(splitWords(s));
  let overlap = 0;
  for (const w of tw) if (sw.has(w)) overlap++;
  return Math.floor((overlap / Math.max(tw.size, sw.size)) * 45);
}

function isVisible(el) {
  if (!el) return false;
  const s = window.getComputedStyle(el);
  if (s.display === "none" || s.visibility === "hidden" || s.opacity === "0") return false;
  const r = el.getBoundingClientRect();
  return r.width > 0 && r.height > 0;
}

function getLabel(el) {
  const raw = el.innerText || el.getAttribute("aria-label") || el.getAttribute("title") || el.value || "";
  return raw.replace(/\s+/g, " ").trim();
}

function getClickableAncestor(el) {
  let node = el;
  while (node && node !== document.body) {
    if (
      node.tagName === "A" || node.tagName === "BUTTON" ||
      node.getAttribute?.("role") === "button" ||
      node.getAttribute?.("role") === "tab" ||
      node.getAttribute?.("role") === "menuitem" ||
      node.onclick != null ||
      window.getComputedStyle(node).cursor === "pointer"
    ) return node;
    node = node.parentElement;
  }
  return null;
}

function _clickByText(target) {
  if (!target) return false;
  const t = target.toLowerCase().trim();

  const pools = [
    [...document.querySelectorAll("nav button, nav a, [class*='sidebar'] button, [class*='sidebar'] a")],
    [...document.querySelectorAll("button, a, [role='button'], [role='tab'], [role='menuitem']")].filter(isVisible),
  ];

  let best = null, bestScore = 0;
  for (const pool of pools) {
    for (const el of pool) {
      const label = getLabel(el);
      if (!label || label.length > 120) continue;
      const score = scoreMatch(t, label.toLowerCase());
      if (score > bestScore) { bestScore = score; best = el; }
      if (bestScore === 100) break;
    }
    if (bestScore >= 80) break;
  }

  if (!best || bestScore < 30) {
    console.warn(`[AI Agent] clickByText: no match for "${target}"`);
    return false;
  }
  const bestTag  = best.tagName;
  const bestRole = best.getAttribute?.("role") || "";
  const isAlreadyClickable = bestTag === "BUTTON" || bestTag === "A" ||
    bestRole === "button" || bestRole === "tab" || bestRole === "menuitem";
  const clickable = isAlreadyClickable ? best : (getClickableAncestor(best) || best);
  highlight(clickable, "#3b82f6");
  triggerClick(clickable);
  return true;
}

function _typeIntoField(target, value) {
  if (!target) return false;
  const t = target.toLowerCase().trim();
  const inputs = [...document.querySelectorAll(
    "input:not([type='hidden']):not([type='submit']):not([type='button']), textarea"
  )].filter(isVisible);

  let best = null, bestScore = 0;
  for (const el of inputs) {
    const sourceParts = [
      el.placeholder || "", el.name || "", el.id || "",
      el.getAttribute("aria-label") || "",
      el.id ? (document.querySelector(`label[for="${el.id}"]`)?.innerText || "") : "",
      el.closest("label")?.innerText || "",
      (el.closest("[class*='form'],[class*='field'],[class*='group'],[class*='col'],[class*='Col']")?.querySelector("label,[class*='label'],[class*='Label'],span,p")?.innerText) || "",
    ];
  
    const tdEl = el.closest("td, th");
    if (tdEl) {
      const trEl    = tdEl.parentElement;
      const tableEl = trEl?.closest("table");
      if (tableEl) {
        const colIdx = [...(trEl?.children || [])].indexOf(tdEl);
        const thEl   = tableEl.querySelector(
          `thead tr th:nth-child(${colIdx + 1}), thead tr td:nth-child(${colIdx + 1})`
        );
        if (thEl?.innerText?.trim()) sourceParts.push(thEl.innerText.trim());
      }
    }

    const parentEl = el.parentElement;
    if (parentEl) {
      for (const sib of parentEl.children) {
        if (sib === el) continue;
        if (sib.querySelector("input,select,textarea")) continue;
        const sibText = sib.innerText?.trim();
        if (sibText && sibText.length > 1 && sibText.length < 80) {
          sourceParts.push(sibText);
          break;
        }
      }
    }
    let prevSib = el.previousElementSibling;
    for (let i = 0; i < 3 && prevSib; i++) {
      const pt = prevSib.innerText?.trim();
      if (pt && pt.length > 1 && pt.length < 80) { sourceParts.push(pt); break; }
      prevSib = prevSib.previousElementSibling;
    }
    const sources = sourceParts.join(" ").toLowerCase();
    const score = scoreMatch(t, sources);
    if (score > bestScore) { bestScore = score; best = el; }
  }

  if (!best || bestScore < 20) {
    console.warn(`[AI Agent] typeIntoField: no match for "${target}"`);
    return false;
  }

  highlight(best, "#10b981");
  best.focus();
  fillReactInput(best, value ?? "");
  setTimeout(() => best.blur(), 100);
  return true;
}

function _cleanLabelText(str) {
  return (str || "").replace(/[*✱✻†‡•]+/g, "").replace(/\s+/g, " ").trim().toLowerCase();
}

function _getCustomSelectLabel(wrapper) {

  const formGroup =
    wrapper.closest(
      '[class*="col"], [class*="form"], [class*="field"], [class*="group"]'
    );

  if (formGroup) {

    const lbl =
      formGroup.querySelector(
        'label.select-floating-label, label'
      );

    if (lbl?.innerText?.trim()) {
      return _cleanLabelText(
        lbl.innerText.trim()
      );
    }
  }

  const placeholder =
    wrapper.querySelector(
      '[class*="placeholder"]'
    )?.innerText?.trim();

  if (placeholder) {
    return _cleanLabelText(
      placeholder
    );
  }

  return "";
}

function _findCustomSelectByLabel(target) {

  target =
    target
      ?.toLowerCase()
      ?.replace("[dropdown]", "")
      ?.trim();

  const controls = [
    ...document.querySelectorAll(
      '.react-select__control, [class$="-control"]'
    )
  ];
  

  let best = null;
  let bestScore = 0;

  for (const control of controls) {

    const formGroup =
      control.closest(
        `
        [class*="form"],
        [class*="field"],
        [class*="group"],
        [class*="col"]
        `
      ) || control.parentElement;

    const label =
    _getCustomSelectLabel(control);

    console.log(
      "TARGET:",
      target,
      "MATCHED:",
      label
    );

    const placeholder =
      control
        .querySelector(
          '.react-select__placeholder, [class*="placeholder"]'
        )
        ?.innerText
        ?.trim()
        ?.toLowerCase() || "";
    console.log(
      "LOOKING FOR",
      target,
      controls.map(c => ({
        label:
          c.closest('[class*="form"],[class*="field"],[class*="group"],[class*="col"]')
            ?.querySelector("label")
            ?.innerText
      }))
    );

    const combined =
      `${label} ${placeholder}`;

    let score = 0;
    if (label === target) {
      score += 1000;
    }

    else if (label.includes(target)) {
      score += 500;
    }

    if (placeholder === target) {
      score += 300;
    }

    if (combined.includes(target)) {
      score += 100;
    }

    if (score > bestScore) {
      bestScore = score;
      best = control;
    }
  }

  if (bestScore < 300) {
    console.warn(
      "No reliable dropdown match for:",
      target
    );
    return null;
  }

  return best;
}


async function _openCustomSelectAndPick(wrapper, wantValue) {
  if (!wrapper) return false;

  wantValue = (wantValue || "")
    .toString()
    .trim()
    .toLowerCase();

  const currentValue =
    wrapper
      .querySelector(
        '.react-select__single-value, [class*="single-value"]'
      )
      ?.innerText
      ?.trim()
      ?.toLowerCase();

  if (
    currentValue === wantValue
  ) {
    return true;
  }

  const control =
    [...(wrapper.classList || [])].some(
      c =>
        c === "react-select__control" ||
        c.endsWith("-control")
    )
      ? wrapper
      : wrapper.querySelector(
          '.react-select__control, [class$="-control"]'
        );

  if (!control) {
    console.warn("react-select control not found");
    return false;
  }

  highlight(control, "#8b5cf6");

  control.scrollIntoView({
    block: "center",
    behavior: "smooth"
  });

  await new Promise(r => setTimeout(r, 300));


  control.focus();

  control.dispatchEvent(
    new PointerEvent("pointerdown", {
      bubbles: true,
      cancelable: true,
      pointerType: "mouse"
    })
  );

  control.dispatchEvent(
    new MouseEvent("mousedown", {
      bubbles: true,
      cancelable: true,
      buttons: 1
    })
  );

  control.dispatchEvent(
    new MouseEvent("mouseup", {
      bubbles: true,
      cancelable: true,
      buttons: 1
    })
  );

  control.click();


  let input =
    control.querySelector(
      'input[id^="react-select-"]'
    ) ||
    control.querySelector(
      'input[aria-autocomplete="list"]'
    ) ||
    control.querySelector("input");

  if (input) {
    input.focus();

    const nativeSetter =
      Object.getOwnPropertyDescriptor(
        HTMLInputElement.prototype,
        "value"
      )?.set;

    nativeSetter?.call(input, wantValue);

    input.dispatchEvent(
      new InputEvent("input", {
        bubbles: true,
        data: wantValue,
        inputType: "insertText"
      })
    );

    input.dispatchEvent(
      new KeyboardEvent("keydown", {
        key: "ArrowDown",
        code: "ArrowDown",
        bubbles: true
      })
    );
  }

  await new Promise(r => setTimeout(r, 800));

  const options = [
    ...document.querySelectorAll(
      '[role="option"], [class*="option"]'
    )
  ].filter(isVisible);

  console.log(
    "FOUND OPTIONS:",
    options.map(o => o.innerText)
  );

  if (!options.length) {
    console.warn("No dropdown options rendered");
    return false;
  }

  let best = null;
  let bestScore = 0;

  for (const opt of options) {
    const txt = opt.innerText
      ?.replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

    if (!txt) continue;

    let score = 0;

    if (txt === wantValue) score = 100;
    else if (txt.startsWith(wantValue)) score = 90;
    else if (txt.includes(wantValue)) score = 75;

    if (score > bestScore) {
      bestScore = score;
      best = opt;
    }
  }

  if (!best) {
    console.warn("Option not found:", wantValue);
    return false;
  }

  highlight(best, "#22c55e");

  best.scrollIntoView({
    block: "center"
  });

  await new Promise(r => setTimeout(r, 200));


  best.dispatchEvent(
    new PointerEvent("pointerdown", {
      bubbles: true,
      cancelable: true,
      pointerType: "mouse"
    })
  );

  best.dispatchEvent(
    new MouseEvent("mousedown", {
      bubbles: true,
      cancelable: true,
      buttons: 1
    })
  );

  best.dispatchEvent(
    new MouseEvent("mouseup", {
      bubbles: true,
      cancelable: true,
      buttons: 1
    })
  );

  best.click();

  if (input) {
    input.dispatchEvent(
      new KeyboardEvent("keydown", {
        key: "Enter",
        code: "Enter",
        bubbles: true
      })
    );
  }

  await new Promise(r => setTimeout(r, 500));

  return true;
  }

function _selectNativeByLabel(target, optionValue) {
  const normT = _cleanLabelText(target);
  const normV = optionValue.toLowerCase().trim();
  for (const sel of document.querySelectorAll("select")) {
    if (!isVisible(sel)) continue;
    const lbl = _cleanLabelText(
      (sel.getAttribute("aria-label") || "") + " " +
      (sel.name || "") + " " + (sel.id || "") + " " +
      (_getCustomSelectLabel(sel) || "")
    );
    if (scoreMatch(normT, lbl) < 45) continue;
    const opt = [...sel.options].find(o =>
      o.text.toLowerCase().includes(normV) || o.value.toLowerCase() === normV
    );
    if (opt) {
      const setter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, "value")?.set;
      if (setter) setter.call(sel, opt.value); else sel.value = opt.value;
      sel.dispatchEvent(new Event("change", { bubbles: true }));
      highlight(sel, "#8b5cf6");
      return true;
    }
  }
  return false;
}

// ─── Cross-tab snapshot ────────────────────────────────────────────────────────
/**
 * Open a same-origin URL in a new tab, wait for the embedded AgentWidget to
 * extract and broadcast the page's DOM snapshot, then return it.
 *
 * Requires that the target page also mounts AgentWidget (which listens for
 * ?__snap=<requestId> and responds via BroadcastChannel "ai_agent_tabsync").
 *
 * @param {string} url     
 * @param {number} timeout  
 * @returns {Promise<{snapshot: string, url: string, error: string|null}>}
 */
export function captureTabSnapshot(url, timeout = 12000) {
  const requestId = Math.random().toString(36).slice(2, 10);
  const isRelative = url.startsWith("/");
  const isSameOrigin = (() => {
    try {
      const u = new URL(url, window.location.origin);
      return u.origin === window.location.origin;
    } catch { return false; }
  })();
  if (!isRelative && !isSameOrigin) {
    return Promise.resolve({ snapshot: "", url, error: "cross-origin tab snapshots are not supported" });
  }

  const channel = new BroadcastChannel("ai_agent_tabsync");

  return new Promise((resolve) => {
    const timer = setTimeout(() => {
      channel.close();
      resolve({ snapshot: "", url, error: "timeout — target page did not respond in time" });
    }, timeout);

    channel.onmessage = (e) => {
      if (e.data?.type === "AGENT_SNAP_RESPONSE" && e.data.requestId === requestId) {
        clearTimeout(timer);
        channel.close();
        resolve({ snapshot: e.data.snapshot || "", url: e.data.url || url, error: null });
      }
    };

    const sep = url.includes("?") ? "&" : "?";
    window.open(`${url}${sep}__snap=${requestId}`, `_agent_snap_${requestId}`, "noopener");
  });
}
